import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import request from "../../api/request";
import { toast } from "react-toastify";

export const AddExpense = createAsyncThunk(
  "main/AddExpense",
  async (data, { getState, rejectWithValue }) => {
    // try {
    //   const token = getState().main.token;
    //   const response = await request.post(
    //     `/api/alfares/schools/expenses/${data.name}/${data.price}/${token}/`
    //   );
    //   toast.success(response.data.message);
    //   return response.data;
    // } catch (error) {
    //   return rejectWithValue(error.message);
    // }
  },
);
export const fetchData = createAsyncThunk(
  "main/fetchData",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.get(`/api/super/fetchData/${token}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const saveResData = createAsyncThunk(
  "main/saveResData",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;

      const formData = new FormData();
      formData.append("data", JSON.stringify(data.data));
      formData.append("image", data.image ? data.image : "");

      const response = await request.post(
        `/api/super/res/edit/${data.data.id}/${token}/`,
        formData,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const addResData = createAsyncThunk(
  "main/addResData",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;

      const formData = new FormData();
      formData.append("data", JSON.stringify(data.data));
      formData.append("image", data.image ? data.image : "");

      console.log(data.data);

      const response = await request.put(`/api/super/res/${token}/`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const editStatusResData = createAsyncThunk(
  "main/editStatusResData",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;

      const response = await request.post(
        `/api/super/res/status/${data.id}/${data.status}/${token}/`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const deleteResData = createAsyncThunk(
  "main/deleteResData",
  async (id, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;

      const response = await request.delete(`/api/super/res/${id}/${token}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
// Slice
export const mainSlice = createSlice({
  name: "main",
  initialState: {
    auth: {},
    isFinanceLogged: false,
    error: null,
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.auth = action.payload.data;
      const userData = {
        token: action.payload.token,
        auth: action.payload.data,
      };

      // Save user data in local storage
      localStorage.setItem("userCredentials", JSON.stringify(userData));

      state.error = null;
    },
    saveDataLocalStorage: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.auth = action.payload.auth;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.isAuthenticated = false;
      state.user = null;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.auth = null;
      state.user = null;
      state.error = null;
      localStorage.removeItem("userCredentials");
    },
    editStatusResDataR: (state, action) => {
      const { id, status } = action.payload;
      const res = state.data.find((res) => res.id === id);
      if (res) {
        res.status = status;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.data = Object.values(action.payload.data);
      state.adminData = Object.values(action.payload.adminData);
    });
  },
});
export const {
  saveDataLocalStorage,
  loginSuccess,
  loginFailure,
  logout,
  removeNote,
  editStatusResDataR,
  loginFinance,
} = mainSlice.actions;
// Export the setTheme action for use in other parts of your application
export const { setTheme } = mainSlice.actions;

export const loginAction = (data) => async (dispatch) => {
  toast.info("جاري تسجيل الدخول", { autoClose: true });
  try {
    const response = await request.post("/api/super/login", data);
    await dispatch(
      loginSuccess({
        data: response.data.data,
        token: response.data.token,
      }),
    );
    await dispatch(fetchData());
    toast.success(response.data.message);
  } catch (error) {
    toast.error("هناك خطا ما في اسم المستخدم او الباسورد", {
      autoClose: true,
    });
    dispatch(loginFailure(error.message));
  }
};
export const saveLogin = (credentials) => async (dispatch) => {
  try {
    await dispatch(
      saveDataLocalStorage({
        token: credentials.token,
        auth: credentials.auth,
      }),
    );
    await dispatch(fetchData());
  } catch (error) {
    toast.error("هناك خطا ما في اسم المستخدم او الباسورد", {
      autoClose: true,
    });
    dispatch(loginFailure(error.message));
  }
};
export const saveResDataAction = (data, image) => async (dispatch) => {
  try {
    await toast.info("جاري تعديل المطعم", { autoClose: true });

    await dispatch(saveResData(data, image));
    await dispatch(fetchData());
    toast.success("تم تعديل المطعم بنجاح", { autoClose: true });
  } catch (error) {
    toast.error("حدث خطا ما ");
  }
};
export const addResDataAction = (data, image) => async (dispatch) => {
  try {
    await toast.info("جاري اضافه المطعم", { autoClose: true });

    await dispatch(addResData(data, image));
    await dispatch(fetchData());
    toast.success("تم اضافه المطعم بنجاح", { autoClose: true });
  } catch (error) {
    toast.error("حدث خطا ما ");
  }
};
export const editStatusResDataAction = (data) => async (dispatch) => {
  try {
    await dispatch(editStatusResData(data));
    await dispatch(fetchData());
  } catch (error) {
    toast.error("حدث خطا ما ", { autoClose: true });
  }
};
export const deleteResDataAction = (id) => async (dispatch) => {
  try {
    await toast.info("جاري حذف المطعم", { autoClose: true });
    await dispatch(deleteResData(id));
    await dispatch(fetchData());
    toast.success("تم حذف المطعم بنجاح", { autoClose: true });
  } catch (error) {
    toast.error("حدث خطا ما ", { autoClose: true });
  }
};
export default mainSlice.reducer;
